import * as yup from 'yup';

import { Regulars } from '@/shared/constants/regulars.constant';

const EMAIL_ERROR_MESSAGE = 'Email is required and must be in a valid format (e.g., user@example.com).';

export const changeProfileFormSchema = yup.object({
	email: yup
		.string()
		.required('Email is required')
		.test('cyrillic-pattern', EMAIL_ERROR_MESSAGE, (value) => {
			return !value || Regulars.CyrillicPattern.test(value);
		})
		.max(50, EMAIL_ERROR_MESSAGE)
		.test('email-regex', EMAIL_ERROR_MESSAGE, (value) => {
			return !value || Regulars.Email.test(value);
		}),
});
